import React, { useState, useEffect, useCallback } from "react";
import { guestAPI } from "../services/api";
import "../styles/PublicPage.css";

const PublicPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchChambre, setSearchChambre] = useState("");
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchGuests = useCallback(async (query = "", chambreQuery = "") => {
    try {
      setLoading(true);
      setError("");

      let response;
      if (query.trim() || chambreQuery.trim()) {
        response = await guestAPI.search(query, chambreQuery);
      } else {
        response = await guestAPI.getAll();
      }

      setGuests(response.data);
    } catch (err) {
      console.error("Error fetching guests:", err);
      setError("Échec du chargement des informations. Veuillez réessayer.");
      setGuests([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGuests(searchTerm, searchChambre);
  }, [searchTerm, searchChambre, fetchGuests]);

  return (
    <div className="public-container">
      <header className="public-header">
        <div className="logo">
          <img src="/dgpLogo.jpg" alt="DGP Logo" className="logo-img" />
          <div>
            <h1>DGP</h1>
            <p className="logo-subtitle">Système de Recherche de Pèlerins</p>
          </div>
        </div>

        <div className="search-container">
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%', maxWidth: '800px', margin: '0 auto' }}>
            <div className="search-box" style={{ flex: 2, marginBottom: 0 }}>
              <input
                type="text"
                placeholder="Rechercher un pèlerin..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
                aria-label="Rechercher des pèlerins"
              />
              <span className="search-icon">🔍</span>
            </div>
            <div className="search-box" style={{ flex: 1, marginBottom: 0 }}>
              <input
                type="text"
                placeholder="N° Chambre..."
                value={searchChambre}
                onChange={(e) => setSearchChambre(e.target.value)}
                className="search-input"
                aria-label="Rechercher par chambre"
              />
              <span className="search-icon">🚪</span>
            </div>
          </div>
          <p className="search-help">
            Recherche par séquence, prénom, nom de famille, numéro de passeport
            ou hôtel. Utilisez le champ de droite pour filtrer par chambre.
          </p>
        </div>

        <div className="admin-access">
          <a href="/admin/login" className="admin-link">
            <span className="lock-icon">🔒</span>
            Connexion Admin
          </a>
        </div>
      </header>

      <main className="public-main">
        <div className="container">
          {error && <div className="error-message public-error">{error}</div>}

          <div className="table-wrapper">
            {loading ? (
              <div className="loading">
                <div className="spinner"></div>
                <p>Chargement des informations sur les pèlerins...</p>
              </div>
            ) : (
              <>
                <div className="table-header">
                  <h2>Liste des Pèlerins</h2>
                  <div className="guest-count">
                    {guests.length}{" "}
                    {guests.length <= 1 ? "pèlerin trouvé" : "pèlerins trouvés"}
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="guest-table">
                    <thead>
                      <tr>
                        <th>Séquence</th>
                        <th>Prénom</th>
                        <th>Nom</th>
                        <th>N° Passeport</th>
                        <th>Hôtel</th>
                        <th>Chambre</th>
                      </tr>
                    </thead>
                    <tbody>
                      {guests.length > 0 ? (
                        guests.map((guest, index) => (
                          <tr key={guest._id || index}>
                            <td className="seq">{guest.Sequence}</td>
                            <td>{guest.prenom}</td>
                            <td>{guest.nom}</td>
                            <td className="passport">{guest.passportNo}</td>
                            <td>{guest.hotel}</td>
                            <td className="room">{guest.chambre}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="no-data"
                            style={{ textAlign: "center", padding: "2rem" }}
                          >
                            {searchTerm
                              ? "Aucun pèlerin ne correspond à votre recherche"
                              : "Liste non disponible"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </main>

      <footer className="public-footer">
        <div className="container">
          <p>
            © DGP Pèlerinage {new Date().getFullYear()}. Tous droits réservés.
          </p>
          <p className="footer-note">Développé par Reflect Studio.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicPage;
